<template>
  <v-container fluid class="shipment-doc-revamp oms-compact-page oms-list-page shipment-docs-page">
    <shipmentDocList v-if="showScreen" />
  </v-container>
</template>
<script>
import _ from "lodash";
import Swal from "sweetalert2";
import shipmentDocList from "./shipmentDocList";
import checkPermissionsMixin from "@/mixins/checkPermissionsMixin";
import Loading from "vue-loading-overlay";

export default {
  mixins: [checkPermissionsMixin],
  components: {
    Loading,
    shipmentDocList,
  },
  created() {
    this.$eventBus.$on("off-load", () => {
      this.loading = false;
    });
    this.$eventBus.$on("on-load", () => {
      this.loading = true;
    });
  },
  data() {
    return {
      showScreen: true,
      items: {
        list: [],
      },
      loading: true,
      search: "",
      payload: {
        skip: "0",
        limit: "15",
      },
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    startLoad() {
      this.loading = true;
    },
    stopLoad() {
      this.loading = false;
    },

    load(event) {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.shipment-docs-page {
  min-width: 0;
}
</style>
